const FiltersCloseIcons = ({ ...props }) => {
  return (
    <svg
      width={props?.width ? props?.width : '12'}
      height={props?.height ? props?.height : '12'}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 0.975781L0.975578 0.000168785L12 11.0242L11.0244 11.9998L0 0.975781Z"
        fill="black"
        fill-opacity="0.56"
      />
      <path
        d="M0.000202105 11.0244L11.0242 0L11.9999 0.975579L0.975815 12L0.000202105 11.0244Z"
        fill="black"
        fill-opacity="0.56"
      />
    </svg>
  )
}

export default FiltersCloseIcons
